import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    totalBorrowed: Number,
    totalRemaining: Number
  }

  connect() {
    console.log("Loan Statistics Chart Controller connected")
    console.log("Total Borrowed:", this.totalBorrowedValue)
    console.log("Total Remaining:", this.totalRemainingValue)
    
    // Check if Chart.js is loaded
    if (typeof Chart === 'undefined') {
      console.error("Chart.js is not loaded!")
      return
    }
    
    if (this.hasTotalBorrowedValue && this.hasTotalRemainingValue) {
      // Add a small delay to ensure DOM is ready
      setTimeout(() => this.initializeChart(), 300)
    } else {
      console.error("Missing chart data values")
    }
  }

  initializeChart() {
    const ctx = document.getElementById('loanStatisticsChart')
    if (!ctx) {
      console.error("Canvas element not found")
      return
    }
    
    const totalBorrowed = this.totalBorrowedValue
    const totalRemaining = this.totalRemainingValue
    const totalPaid = totalBorrowed - totalRemaining
    
    console.log("Creating chart with data:", { totalPaid, totalRemaining })
    
    try {
      new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Pagado', 'Pendiente por Pagar'],
          datasets: [{
            data: [totalPaid, totalRemaining],
            backgroundColor: [
              'rgba(69, 123, 157, 0.7)',
              'rgba(191, 23, 36, 0.7)'
            ],
            borderColor: [
              'rgba(69, 123, 157, 1)',
              'rgba(191, 23, 36, 1)'
            ],
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom'
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const value = context.raw
                  return new Intl.NumberFormat('es-CO', { 
                    style: 'currency', 
                    currency: 'COP',
                    maximumFractionDigits: 0
                  }).format(value)
                }
              }
            }
          }
        }
      })
      console.log("Chart created successfully")
    } catch (error) {
      console.error("Error creating chart:", error)
    }
  }
}
